import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import MenuIcon from 'material-ui/svg-icons/navigation/menu';
import ViewModule from 'material-ui/svg-icons/action/view-module';
import {white} from 'material-ui/styles/colors';
import Loading from '../Loading/Loading';
import openiumLogo from '../../../resources/images/openium/logo-openium-m-white.svg';
import {Link} from 'react-router-dom';
import style from './Header.css';
import defaultStyles from '../../../styles/styles'
import {getApps} from '../../../store/apps/actions';
import withTranslation from "../../../hoc/withTranslation";
import {APPLICATION_PAGE, DASHBOARD} from "../../../constants/routes";

export class Header extends React.Component {

    render() {
        const title = this.props.t('generic.dashboard') + ' / Openium';
        const {styles, handleChangeRequestNavDrawer, presentationMode} = this.props;

        let appBarTitle = null;
        let appBarLeftElement;
        let appBarRightElement;

        if (presentationMode) {
            appBarLeftElement =
                <Link to={DASHBOARD}>
                    <div style={style.presentation.container}>
                        <img style={style.presentation.logo} src={openiumLogo} alt="logo"/>
                        <span style={style.presentation.span}>{title}</span>
                    </div>
                </Link>;
        } else {
            appBarLeftElement =
                <div style={style.presentation.container}>
                    <IconButton style={style.menuButton} onClick={handleChangeRequestNavDrawer}>
                        <MenuIcon color={white} />
                    </IconButton>
                    <span style={style.presentation.span}>{title}</span>
                </div>;
        }
        if (this.props.appError) {
            appBarRightElement = (
                <div style={style.iconsRightContainer}/>
            );
        } else if (this.props.appsLoading || !this.props.apps) {
            appBarRightElement = <Loading paper={false} />;

        } else {
            let appsMenuItems = this.props.apps.map(function(app, index) {
                return (
                    <Link key={index} to={APPLICATION_PAGE.replace(':appId', app.id)} >
                        <MenuItem key={app.id} primaryText={app.name} />
                    </Link>
                );
            });
            appBarRightElement = (
                <div style={style.iconsRightContainer}>
                    <IconMenu color={white}
                              iconButtonElement={
                                  <IconButton>
                                      <ViewModule color={white}/>
                                  </IconButton>
                              }
                              listStyle={defaultStyles.list}
                              targetOrigin={{horizontal: 'right', vertical: 'top'}}
                              anchorOrigin={{horizontal: 'right', vertical: 'top'}}>
                        {appsMenuItems}
                    </IconMenu>
                </div>
            );
        }

        return (
            <div>
                <AppBar
                    style={{...styles, ...style.appBar}}
                    title={appBarTitle}
                    iconElementLeft={appBarLeftElement}
                    iconElementRight={appBarRightElement}
                />
            </div>
        );
    }
}

Header.propTypes = {
    styles: PropTypes.object,
    handleChangeRequestNavDrawer: PropTypes.func,
    presentationMode: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending,
        appError: state.apps.error
    };

    if (state.apps.content) {
        props.apps = state.apps.content;
    }
    return props;
}

export default connect(mapStateToProps, {getApps})(withTranslation(Header));



// WEBPACK FOOTER //
// src/components/common/Header/Header.js